import BaseLP from 'services/sports/default/base-lp';

export default class LP extends BaseLP {
    subjectToPermanent() {
        const constraints = {
            players: this.exec('prepareSectionByPlayer', {}, ''),
            salary: this.exec('prepareSectionBySalary', {}, ''),
            projectedOwnershipCap: this.exec('projectedOwnership', {}, ''),
            projectedOwnershipForce: this.exec(
                'forceOfProjectedOwnership',
                {
                    filterByPositions: false,
                },
                '',
            ),
            positions: this.exec('prepareSectionByPosition', {}, ''),
            // teams: this.exec('prepareSectionByFighters', {}, ''),
        };
        // console.log('constraints',{...constraints});
        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            opposingOpponentsInLineup: this.exec('opposingOpponentsInLineup', {}, ''),
            createdLineups: this.exec('prepareSectionByCreatedLineups', {}, ''),
            exposureMax: this.exec('prepareSectionByExposureMax', {}, ''),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            playerCombinationStacking: this.exec('playerCombinationStacking', {}, ''),
        };
        return {...constraints};
    }
}
